import React, {
  Fragment,
  useEffect,
  useContext,
  useState,
  forwardRef,
} from "react";
import MaterialTable from "material-table";
import { Switch, TextField } from "@material-ui/core";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FirstPage,
  LastPage,
  FilterList,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

// Contexts
import UserContext from "../../context/users/UserContext";
import ParameterContext from "../../context/parameters/ParameterContext";
import PatchedPagination from "../layout/MTPagination";

const UserSearch = ({ classes }) => {
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const { users, updateUser } = useContext(UserContext);
  const { user_group } = useContext(ParameterContext);

  const [rows, setRows] = useState([]);
  let errors = {
    name: "",
    email: "",
  };

  useEffect(() => {
    if (users) {
      setRows(users);
    }
  }, [users]);

  const column = [
    {
      field: "name",
      title: "Username",
      render: (rowData) => rowData.name,
      editable: "onUpdate",
      editComponent: (props) => (
        <Fragment>
          <TextField
            InputProps={{
              classes: {
                input: classes.field,
              },
            }}
            type="text"
            value={props.value ? props.value : ""}
            onChange={(e) => {
              props.onChange(e.target.value);
            }}
            error={errors.name ? true : false}
            helperText={errors.name ? errors.name : ""}
          />{" "}
        </Fragment>
      ),
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
    {
      field: "email",
      title: "Email",
      // render: (rowData) => rowData.email,
      editable: "never",
      // editable: "onUpdate",
      // editComponent: (props) => (
      //   <Fragment>
      //     <TextField
      //       InputProps={{ classes: { input: classes.field } }}
      //       type="email"
      //       value={props.value ? props.value : ""}
      //       onChange={(e) => {
      //         props.onChange(e.target.value);
      //       }}
      //       error={errors.email ? true : false}
      //       helperText={errors.email ? errors.email : ""}
      //     />
      //   </Fragment>
      // ),
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
    {
      field: "user_group",
      title: "User Group",
      render: (rowData) => rowData.user_group,
      editable: "onUpdate",
      editComponent: (props) => (
        <Fragment>
          <TextField
            InputProps={{
              classes: {
                input: classes.field,
              },
            }}
            select
            SelectProps={{
              native: true,
            }}
            value={props.value}
            onChange={(e) => {
              props.onChange(e.target.value);
            }}
          >
            {user_group.map((each) => {
              return (
                <option key={each.user_group} value={each.user_group}>
                  {" "}
                  {each.user_group_name}{" "}
                </option>
              );
            })}{" "}
          </TextField>{" "}
        </Fragment>
      ),
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
    {
      field: "status",
      title: "Status",
      render: (rowData) => rowData.status,
      editable: "onUpdate",
      editComponent: (props) => (
        <Fragment>
          {" "}
          {/* <Switch
                                                                                                color="primary"
                                                                                                checked={props.value === "Active" ? true : false}
                                                                                                onChange={(e) => {
                                                                                                  props.onChange(e.target.checked ? "Active" : "Inactive");
                                                                                                }}
                                                                                              />
                                                                                              <span>Active</span> */}
          <TextField
            InputProps={{
              classes: {
                input: classes.field,
              },
            }}
            select
            SelectProps={{
              native: true,
            }}
            value={props.value}
            onChange={(e) => {
              props.onChange(e.target.value);
            }}
          >
            <option value="Active"> Active </option>{" "}
            <option value="Inactive"> Inactive </option>{" "}
            <option value="Lock"> Lock </option>{" "}
          </TextField>{" "}
        </Fragment>
      ),
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
  ];

  return (
    <Fragment>
      <MaterialTable
        data={rows}
        columns={column}
        title="Users"
        icons={tableIcons}
        localization={{
          header: {
            actions: "Actions",
          },
          body: {
            editTooltip: "Edit User",
            editRow: {
              saveTooltip: "Save",
            },
          },
        }}
        editable={{
          onRowUpdateCancelled: () => {
            errors = {
              name: "",
              email: "",
            };
          },
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                const index = oldData.tableData.id;
                rows[index] = newData;

                let valid = true;
                // const validEmailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                if (newData.name === "") {
                  errors.name = "Name cannot be empty.";
                  valid = false;
                } else {
                  errors.name = "";
                }

                // if (newData.email === "") {
                //   errors.email = "Email cannot be empty.";
                //   valid = false;
                // } else if (!validEmailRegex.test(newData.email)) {
                //   errors.email = "Email is invalid.";
                //   valid = false;
                // } else {
                //   for (let x in rows) {
                //     if (
                //       x !== index.toString() &&
                //       rows[x].email === newData.email
                //     ) {
                //       errors.email = "Email already exists.";
                //       valid = false;
                //     }
                //   }

                //   if (valid) errors.email = "";
                // }

                if (valid) {
                  updateUser(newData);
                  resolve();
                } else {
                  reject();
                  return;
                }
              }, 500);
            }),
        }}
        options={{
          sorting: true,
          showTitle: true,
          actionsColumnIndex: -1,
          pageSizeOptions: [10, 25, 50],
          pageSize: 25,
          padding: "dense",
          headerStyle: {
            fontWeight: "bold",
            fontSize: 13,
            zIndex: 0,
          },
        }}
        components={{
          Pagination: PatchedPagination,
        }}
      />{" "}
    </Fragment>
  );
};

export default UserSearch;
